import { PDMS_LINUX } from '@/constants.js'
const path = require('path')

const PATHS = {
	install (Vue, options) {
		Vue.prototype.$paths = {

			maestroToUNC (maestro_path) {
				if (maestro_path.indexOf('.cmc.fr') > -1) maestro_path = maestro_path.replace('.cmc.fr', '')
				if (maestro_path.split('/').length <= 2) {
					return maestro_path
				}
				if (maestro_path.split('/')[1].toLowerCase() !== 'media' &&
				maestro_path.split('/')[2].toLowerCase() !== 'data') {
					return maestro_path
				}
				let rootArr = maestro_path.split('/').filter(Boolean).splice(0, 3)
				let rootPath = '/' + rootArr.join('/')
				if (PDMS_LINUX.hasOwnProperty(rootPath)) {
					let unc_path = maestro_path.replace(rootPath, PDMS_LINUX[rootPath].unc_path)
					return unc_path
				}
				let arr_path = maestro_path.split('/').filter(Boolean).splice(2)
				let ip_server = arr_path[0].split('_')
				arr_path.splice(0, 1)
				let unc_path = ['/', ...ip_server, ...arr_path].join('/')
				return unc_path
			},

			UNCToMaestro (unc_path) {
				if (!unc_path) return ''
				let norm_path = path.normalize(unc_path.replace(/\\/g, '/'))
				let addTrailingSlash = false
				if (norm_path[norm_path.length - 1] === '/') addTrailingSlash = true
				let path_parts = norm_path.slice(1).split(path.sep)
				let converted_path = unc_path
				if (!converted_path.includes('/media/DATA')) {
					let unc_converted = path_parts.slice(0, 2).map(part => {
						return part.toLowerCase()
					}).join('_')
					converted_path = path.join(
						'/media/DATA/',
						unc_converted,
						path.join(
							...path_parts.slice(2)
						)
					)
				}
				if (addTrailingSlash && converted_path[converted_path.length - 1] !== '/') {
					converted_path += '/'
				}
				return converted_path
			},

			pathBasename (input_path) {
				return path.basename(input_path)
			},

			buildPath (...args) {
				return args.map((part, i) => {
					if (i === 0) {
						return part.trim().replace(/[/]*$/g, '')
					} else {
						return part.trim().replace(/(^[/]*|[/]*$)/g, '')
					}
				}).filter(x => x.length).join('/')
			}

		}
	}
}

export default PATHS



// WEBPACK FOOTER //
// ./src/plugins/paths.js